import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {GameLogicService} from "../../services/game-logic.service";
import {Result} from '../../constants/Result';
import {ErrorHandlerService} from "../../services/error-handler.service";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})

export class SidebarComponent implements OnInit {
  @Input() time;
  @Input() length;
  @Input()  height;
  @Input()  mines;
  @Input() result;

  @Output() onBoardChange = new EventEmitter<any>();

  public boardParams = {
    newLength:0 ,
    newHeight:0,
    newMines: 0
  };
  public error = false;
  public errorMessage:string;
  public difficulty: string;
  public resultEnum = Result;

  constructor(private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {
    this.boardParams.newLength = this.length;
    this.boardParams.newHeight = this.height;
    this.boardParams.newMines = this.mines;
  }

  updateBoard(){
    if (this.errorHandlerService.checkErrors(this.boardParams.newMines,this.boardParams.newHeight,this.boardParams.newLength)){
      this.error= true;
      this.errorMessage = this.errorHandlerService.getErrorMessage();
      return;
    }
    this.error = false;
    this.onBoardChange.emit(this.boardParams);
  }

  changeDifficulty(){
    switch(this.difficulty){
      case('Easy'):
        this.boardParams.newLength = 9;
        this.boardParams.newHeight = 9;
        this.boardParams.newMines = 10;
        break;
      case('Medium'):
        this.boardParams.newLength = 16;
        this.boardParams.newHeight = 16;
        this.boardParams.newMines = 40;
        break;
      case('Hard'):
        this.boardParams.newLength = 16;
        this.boardParams.newHeight = 30;
        this.boardParams.newMines = 99;
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/minesweeper/components/sidebar/sidebar.component.ts